import React from 'react';
import PersonnelDocuments from '@/components/PersonnelDocuments';
import { hasCap } from '@/lib/capabilities';
import { useEffectiveMe } from '@/lib/effectiveMe';

export default function MieiDocumenti() {
  const me = useEffectiveMe();
  const hasSelfDocumentCapability = (code) => hasCap(me, code) || hasCap(me, 'self.documents.*');
  return <PersonnelDocuments mode="self" capabilities={{
    canRead: hasCap(me, 'self.view'),
    canSelfUpload: hasSelfDocumentCapability('self.documents.upload'),
    canSelfReplace: hasSelfDocumentCapability('self.documents.replace'),
    canSelfDelete: hasSelfDocumentCapability('self.documents.delete'),
  }} />;
}
